import script from "./AccessibilityOptionsWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccessibilityOptionsWidget.vue?vue&type=script&lang=ts&setup=true"

import "./AccessibilityOptionsWidget.vue?vue&type=style&index=0&id=312e5bad&lang=scss"

const __exports__ = script;

export default __exports__